import {Box} from "@chakra-ui/react";
import Footer from '../../layouts/Footer';
import Header from '../../layouts/Header';
import ClaimPaymentTokenBody from '../../components/ClaimPaymentTokenBody';

const ClaimPaymentToken = (props) => {

	return(
		<Box>
      <Header />
			<ClaimPaymentTokenBody/>
      <Footer />
		</Box>
	)
}

export default ClaimPaymentToken;